<template>
    <div class="contact-content">
        <el-popover placement="left" :width="100" trigger="hover">
            <div class="cont-m" slot="reference">
                <p class="tel" style="margin-bottom: 20px;">
                    <i></i>
                    <span>合作电话</span>
                </p>
            </div>
            <div class="cont-t">
                <p>
                    18913931035
                </p>
            </div>
        </el-popover>
        <el-popover placement="left" :width="300" trigger="hover">
            <div class="cont-m" slot="reference">
                <p class="address" style="margin-bottom: 20px;">
                    <i></i>
                    <span>办公地址</span>
                </p>
            </div>
            <div class="cont-t">
                <img src="../../assets/img/bottom/address.png"
                    width="275"
                    alt="">
                <p style="font-size: 14px;">南京市秦淮区永丰大道天安数码城4栋8楼</p>
            </div>
        </el-popover>
        <el-popover placement="left" :width="200" trigger="hover">
            <div class="cont-m" slot="reference">
                <p class="email">
                    <i></i>
                    <span>电子邮箱</span>
                </p>
            </div>
            <div class="cont-t">
                <p>yysmart@autof.cn</p>
            </div>
        </el-popover>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.contact-content {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 0 0 6px 1px rgba($color: #000, $alpha: 0.12);
    z-index: 999;
    right: 1px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px 5px;
    .cont-m {
        opacity: 0.5;
        &:last-child {
            margin-bottom: 0;
        }
        p {
            text-align: center;
            font-size: 15px;
            cursor: pointer;
            &:hover {
                color: $themeColor;
            }
        }
        i { 
            display: block;
            margin-bottom: 5px;
            background-position: center center;
            background-repeat: no-repeat;
            margin-left: 50%;
            transform: translateX(-50%);
        }
        .phone  {
            i {
                background-image: url('../../assets/img/icon/phone.png');
                width: 13px;
                height: 18px;
            }
            &:hover {
                i {
                    background-image: url('../../assets/img/icon/phone_hover.png');
                }
            }
        }
        .weichat {
            i {
                background-image: url('../../assets/img/icon/chat.png');
                width: 22px;
                height: 22px;
            }
            &:hover {
                i {
                    background-image: url('../../assets/img/icon/chat_hover.png');
                }
            }
        }
        .qq {
            i {
                background-image: url('../../assets/img/icon/qq.png');
                width: 14px;
                height: 16px;
            }
            &:hover {
                i {
                    background-image: url('../../assets/img/icon/qq_hover.png');
                }
            }
        }
        .tel  {
            i {
                background-image: url('../../assets/img/icon/tel.png');
                width: 17px;
                height: 20px;
            }
            &:hover {
                i {
                    background-image: url('../../assets/img/icon/tel_hover.png');
                }
            }
        }
        .address  {
            i {
                background-image: url('../../assets/img/icon/address.png');
                width: 18px;
                height: 20px;
            }
            &:hover {
                i {
                    background-image: url('../../assets/img/icon/address_hover.png');
                }
            }
        }
        .email  {
            i {
                background-image: url('../../assets/img/icon/email.png');
                width: 19px;
                height: 14px;
            }
            &:hover {
                i {
                    background-image: url('../../assets/img/icon/email_hover.png');
                }
            }
        }
    }
}
</style>
<style lang="scss">
.cont-t {
    p {
        text-align: center;
        font-size: 18px;
        color: $themeColor;
    }
}
</style>